import { Component, OnInit } from '@angular/core';
import {
  ColDef,
  ColumnApi,
  GetContextMenuItemsParams,
  GridApi,
  GridReadyEvent,
  IServerSideGetRowsParams
} from "ag-grid-community";
import {environment} from "../../../environments/environment";
import {HttpService} from "../../services/http.service";
import {HistoryDialogComponent} from "../dialogs/history-dialog/history-dialog.component";

@Component({
  selector: 'app-grid-collections',
  templateUrl: './grid-collections.component.html',
  styleUrls: ['./grid-collections.component.scss']
})
export class GridCollectionsComponent implements OnInit {
  public columnDefs: ColDef[] = [
    {
      field: '_id',
      headerName: 'id',
      hide: true,
      editable: false,
      filter: 'agTextColumnFilter',
      suppressFiltersToolPanel: true,
      suppressColumnsToolPanel: true,
    },
    {
      field: 'shopify_collection_id',
      headerName: 'Shopify ID',
    },
    {
      field: 'handle',
      headerName: 'Handle',
      editable: true,
    },
    {
      field: 'title',
      headerName: 'Title',
      editable: true,
    },
    {
      field: 'count',
      headerName: 'Products count'
    },
    {
      field: 'show_in_menu',
      headerName: 'Use in Nav Menu',
      editable: true,
      maxWidth: 170,
      cellEditor: 'agRichSelectCellEditor',
      cellEditorParams: {
        values: [true, false],
      },
    }
  ];
  public defaultColDef: ColDef = {
    flex: 1,
    minWidth: 170,
    sortable: true,
    editable: false,
    filter: false,
    resizable: true,
  };

  private gridApi?: GridApi;
  private columnApi?: ColumnApi;
  constructor(
    private httpService: HttpService,
  ) { }

  ngOnInit(): void {
  }

  cellValueChanged($event: any): void {
    console.log('cellValueChanged ----- $event', $event);
    if ($event.colDef.field === 'show_in_menu') {
      this.httpService.post(environment.API_PATH + '/ai/change-collection-menu-state', {
        shopify_collection_id: $event.data.shopify_collection_id,
        show_in_menu: $event.data.show_in_menu
      }).subscribe();
    } else if ($event.colDef.field === 'title') {
      this.httpService.post(environment.API_PATH + '/ai/change-collection-title', {
        shopify_collection_id: $event.data.shopify_collection_id,
        title: $event.data.title

      }).subscribe();
    } else if ($event.colDef.field === 'handle') {
      this.httpService.post(environment.API_PATH + '/ai/change-collection-handle', {
        shopify_collection_id: $event.data.shopify_collection_id,
        handle: $event.data.handle
      }).subscribe();
    }
  }

  getContextMenuItems = (params: GetContextMenuItemsParams) => {
    return [
      'separator',
      {
        name: 'Open <b>Stage</b> Shopify Admin Page',
        disabled: false,
        icon: '<span class="ag-icon ag-icon-eye" unselectable="on" role="presentation"></span>',
        action: () => {
          window.open('https://admin.shopify.com/store/bhawk1/collections/' + params?.node?.data.shopify_collection_id.split('/').slice(-1)[0], '_blank');
        }
      },
      'separator',
    ];
  }

  onGridReady(params: GridReadyEvent) {
    this.gridApi = params.api;
    this.columnApi = params.columnApi;

    const that = this;
    this.gridApi.setServerSideDatasource({
      getRows(params: IServerSideGetRowsParams) {
        const {startRow, endRow, rowGroupCols, groupKeys, filterModel, sortModel} = params.request;
        const body = {startRow, endRow, rowGroupCols, groupKeys, filterModel, sortModel};
        that.httpService.post(environment.API_PATH + '/ai/get-collections', body).subscribe((dataAndCount) => {
          const receivedData = dataAndCount as { rows: {}[], count: number };
          params.success({
            rowData: receivedData.rows,
            rowCount: receivedData.count
          });
        });
      }
    });
  }
}
